import { combineReducers } from 'redux';

import { FETCH_PAGINATED_ENTITY_SUCCESS } from '@store/entity/actions';

export const createReducerForEntity = (entityName) => {
  const initialPaginationState = {
    result: [],
    total: 0,
  };

  return (state = initialPaginationState, action) => {
    const { payload } = action;
    switch (action.type) {
      case FETCH_PAGINATED_ENTITY_SUCCESS: {
        if (payload.pagination[entityName]) {
          return {
            ...payload.pagination[entityName],
            result: payload.data.result[entityName],
          };
        }
        return state;
      }
      default: {
        return state;
      }
    }
  };
};

export default combineReducers({
  spaDays: createReducerForEntity('spaDays'),
  spaPackages: createReducerForEntity('spaPackages'),
  spaPackagesAll: createReducerForEntity('spaPackagesAll'),
  spaTreatments: createReducerForEntity('spaTreatments'),
  facilities: createReducerForEntity('facilities'),
});
